.categorySelector {
  display: flex;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  background: var(--colors-background);
}

@media (--reefer-media-tablet-max) {
  .categorySelector {
    margin-right: calc(var(--page-margin) * -1);
    margin-left: calc(var(--page-margin) * -1);
  }

  .categoryTabsWrapper {
    padding-left: var(--page-margin);
    padding-right: var(--page-margin);
  }
}

.categorySelector::-webkit-scrollbar {
  display: none;
}
